"use client"

import { useState, useEffect } from "react"
import styles from "../../styles/AboutUs.module.css"
import ceo from "../../assets/redi.png"
import samuel from "../../assets/samuel.jpg"
import engedawerk from "../../assets/engedawerk.jpg"
import tegegn from "../../assets/tegegn.jpg"
import eyerus from "../../assets/eyerus.jpg"
import abreham from "../../assets/abreham.png"
import asegid from "../../assets/assegid.PNG"

const TeamSection = () => {
  const [activeCard, setActiveCard] = useState(null)
  const [isMobile, setIsMobile] = useState(false)

  const teamMembers = [
    {
      id: 1,
      name: "Rediet Tsigeberhan",
      position: "CEO ",
      image: ceo,
      bio: "Visionary leader with 15+ years of industry experience driving innovation and product development, having held executive roles including Chief Technology Officer at Kifiya and Elnet Business Group and Technology Delivery Director at Excellerent, one of the largest technology outsourcing companies. ",
      linkedin:
        "https://www.linkedin.com/in/rediet-tsigeberhan-97615642?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    {
      id: 2,
      name: "Samuel Alemu",
      position: "Board Chairman",
      image: samuel,
      bio: "Samuel Alemu, Esq. is a Harvard-trained attorney with over 20 years of global legal experience, now serving as Managing Partner at ILBSG, with a presence in Chicago, New York, Los Angeles, and South Carolina. He is also a co-founder of Lex Nimble Solutions, a legal tech and IT consulting firm. He is a co-founder of Simplelaw.com, an intuitive collaboration platform. He has been admitted to the bar associations of New York State, the United States Tax Court, the United States Court of International Trade, and the United States District Court for the Northern District of Illinois.",
      linkedin: "https://www.linkedin.com/in/samuelalemuesq",
    },
    {
      id: 3,
      name: "Dr. Enawgaw Mehari",
      position: "Board Member",
      image: engedawerk,
      bio: "Dr.Enawgaw Mehari, MD is an Ethiopian‑born, board‑certified neurologist with over 20 years of U.S. practice, founder/president of People to People, Inc., and chief of neurology specializing in pain, neuro‑AIDS, dementia and Parkinson's care",
      linkedin: "https://www.linkedin.com/in/enawgaw-mehari-ab612130",
    },
    {
      id: 4,
      name: "Dr. Tegegnework Gettu",
      position: "Board Member",
      image: tegegn,
      bio: "Dr. Tegegnework Gettu, PhD (Columbia University), is a seasoned development economist and Ethiopian UN Under‑Secretary‑General who later chaired Ethiopia's Liability & Asset Management Corporation.",
      linkedin: "https://www.linkedin.com/in/tegegnework-gettu-33856110?utm_source=chatgpt.com",
    },
    // {
    //   id: 6,
    //   name: "Eyerusalem Assefa",
    //   position: "Board Member",
    //   image: eyerus,
    //   bio: "Eyerusalem Assefa is a compliance and development professional with experience in auditing, finance, and education. She currently works at First Consult PLC and serves on the board of Arifpay Financial Technologies.",
    // },
    {
      id: 7,
      name: "Dr. Abraham Betre",
      position: "Board Member",
      image: abreham,
      bio: "Dr. Abraham Betre, D.O., is a board-certified Obstetrician-Gynecologist with over 20 years of experience providing comprehensive women's healthcare—from routine gynecology to high-risk pregnancy—across Central California.",
      linkedin: "https://www.linkedin.com/in/dr-betre-email-1048177a",
    },
    {
      id: 8,
      name: "Asegid Assefa",
      position: "Board Member",
      image: asegid,
      bio: "A seasoned professional with 30+ years of experience in project management, consulting, marketing, and logistics. Currently a self-employed consultant and Advisory Board Member at Adama Development PLC, with past leadership roles in PSD-Hub (SIDA), ECF (World Bank), MIDROC Construction, and public institutions.",
    },
  ]

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkIsMobile()
    window.addEventListener("resize", checkIsMobile)
    return () => window.removeEventListener("resize", checkIsMobile)
  }, [])

  const getDisplayBio = (bio, memberId) => {
    const MAX_BIO_LENGTH = 150
    if (isMobile && bio.length > MAX_BIO_LENGTH && activeCard !== memberId) {
      return bio.substring(0, MAX_BIO_LENGTH) + "..."
    }
    return bio
  }

  const handleCardClick = (linkedinUrl) => {
    if (linkedinUrl) {
      window.open(linkedinUrl, "_blank")
    }
  }

  const renderCard = (member) => (
    <div
      key={member.id}
      className={`${styles.teamCard} ${activeCard === member.id ? styles.activeCard : ""}`}
      onMouseEnter={() => !isMobile && setActiveCard(member.id)}
      onMouseLeave={() => !isMobile && setActiveCard(null)}
      onClick={() => {
        if (isMobile) {
          setActiveCard(activeCard === member.id ? null : member.id)
        }
      }}
    >
      <div className={styles.cardInner}>
        <img src={member.image || "/placeholder.svg"} alt={member.name} className={styles.memberImage} />
        <div
          className={`${styles.cardOverlay} ${
            activeCard === member.id || (isMobile && activeCard === member.id) ? styles.visibleOverlay : ""
          }`}
        >
          <div className={styles.overlayContent}>
            <div className={styles.overlayHeader}>
              <h3 className={styles.overlayName}>{member.name}</h3>
              <p className={styles.overlayPosition}>{member.position}</p>
            </div>

            <div className={styles.scrollableBio}>
              <p className={styles.overlayBio}>
                {getDisplayBio(member.bio, member.id)}
                {isMobile && member.bio.length > 150 && activeCard !== member.id && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveCard(member.id)
                    }}
                    className={styles.readMore}
                  >
                    {" "}
                    Read More
                  </span>
                )}
                {isMobile && member.bio.length > 150 && activeCard === member.id && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveCard(null)
                    }}
                    className={styles.readLess}
                  >
                    {" "}
                    Show Less
                  </span>
                )}
              </p>
            </div>

            {member.linkedin && (
              <div
                className={styles.linkedinLink}
                onClick={(e) => {
                  e.stopPropagation()
                  handleCardClick(member.linkedin)
                }}
              >
                <span>View LinkedIn</span>
                <svg className={styles.linkedinIcon} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </div>
            )}
          </div>
        </div>
        <div className={styles.cardFooter}>
          <h3 className={styles.memberName}>{member.name}</h3>
          <p className={styles.memberPosition}>{member.position}</p>
        </div>
      </div>
    </div>
  )

  return (
    <section className={styles.gallerySection}>
      <div className={styles.galleryContainer}>
        <h2 className={styles.sectionTitle}>
          Who's <span className={styles.highlight}>Leading</span> us
        </h2>

        <div className={styles.boardSection}>
          <h3 className={styles.subheading}>Our Board Members</h3>
          <div className={styles.teamGrid}>{teamMembers.slice(1).map(renderCard)}</div>
        </div>

        <div className={styles.ceoSection}>
          <div className={styles.ceoWrapper}>
            <h3 className={styles.subheading}>Our CEO</h3>
            {renderCard(teamMembers[0])}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TeamSection